import { Component, OnInit, AfterViewInit } from '@angular/core';
declare var AOS: any;
@Component({ selector: 'app-sol-insurance', templateUrl: './insurance.component.html', styleUrls: ['./insurance.component.scss'], standalone: false })
export class InsuranceBFSIComponent implements OnInit, AfterViewInit {
  activeSection = 'overview';
  sections = [
    { id: 'overview', label: 'Overview', icon: 'bx-layer' },
    { id: 'features', label: 'Features', icon: 'bx-chip' },
    { id: 'outcomes', label: 'Outcomes', icon: 'bx-bar-chart-alt-2' },
  ];
  features = [
    { icon: 'bx-brain', title: 'UBI Risk Scoring', desc: 'Real-time usage-based insurance scoring using driving patterns, speed, braking, and route data.' },
    { icon: 'bx-car', title: 'Crash Detection & FNOL', desc: 'Automatic crash detection with instant First Notice of Loss reporting to reduce claims processing time.' },
    { icon: 'bx-user-check', title: 'Driver Verification', desc: 'Continuous driver identity verification using biometrics and behaviour patterns to combat fraud.' },
    { icon: 'bx-analyse', title: 'Portfolio Analytics', desc: 'Fleet-wide risk visualisation and loss-ratio modelling for actuarial underwriting and pricing.' },
    { icon: 'bx-cctv', title: 'Event Recording', desc: 'Incident video and data retrieval for claims investigation and liability determination.' },
    { icon: 'bx-shield-alt-2', title: 'Regulatory Compliance', desc: 'IRDAI, FCA, and global insurance data regulation compliance built into every data pipeline.' },
  ];
  metrics = [
    { val: '40%', label: 'Claims Cost Reduction' },
    { val: '3x', label: 'Fraud Detection Rate' },
    { val: '60%', label: 'Faster FNOL Processing' },
  ];
  ngOnInit() {}
  ngAfterViewInit() { try { AOS.refresh(); } catch (e) {} }
  scrollTo(id: string) {
    this.activeSection = id;
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
